//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TransientObject.js";
let d=[[[0,"CrossDegree",1,0],[0,"CrossMaxDegree",1,0],[0,"CrossMaxSegments",1,0],[0,"CrossRebuildType",1,0],[0,"PrimaryDegree",1,0],[0,"PrimaryMaxDegree",1,0],[0,"PrimaryMaxSegments",1,0],[0,"PrimaryRebuildType",1,0]],[[[],"Dispose",{},0,0],[["tolerances"],"SetTolerances",{},1,0],[["num_tolerances"],"GetTolerances",{R_:{tolerances:""}},1,0]],[]];
SPLM.SurfaceRebuildData = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SurfaceRebuildData";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.SurfaceRebuildData.Type = Object.freeze({
    "None" : "None", "Manual" : "Manual", "Auto" : "Auto"});

export default SPLM;